module.exports = __webpack_public_path__ + "static/media/avive_aed_unaccepted_hover.23f098a7.svg";